/**
 * Convert seconds to a formatted string (Days, Hours, Minutes, Seconds)
 * @param {number} totalSeconds - The total time in seconds.
 * @returns {object} A object with different formatted string showing the time in days, hours, minutes, and seconds.
 */
export default function formatSecondsToDHMS(totalSeconds) {
    const days = Math.floor(totalSeconds / (3600 * 24)); // Calculate days
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600); // Calculate hours
    const minutes = Math.floor((totalSeconds % 3600) / 60); // Calculate minutes
    const seconds = totalSeconds % 60; // Calculate remaining seconds
  
    // Return formatted string
    return{ 
       v1 : `${days ? days + 'd:' : ''}${hours ? hours + 'h:' : ''}${minutes? minutes + 'm:' : ''}${seconds}s`
    };
  }